import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { EdsComponent } from 'src/app/components/dialog/eds/eds.component';
import { MarkingProductCreateComponent } from 'src/app/components/dialog/integrations/marking-product-create/marking-product-create.component';
import { MarkingProductProfileComponent } from 'src/app/components/dialog/integrations/marking-product-profile/marking-product-profile.component';
import { ACTIONS_LIST } from 'src/app/constants';
import { ActionsList, PaginationPageEvent, Res } from 'src/app/models';
import { MarkingProductData } from 'src/app/models/integrations/marking/marking-product-list.model';
import { ApiMarkingProductListService, DialogModalService, LanguageService, NotificationService, PermissionService } from 'src/app/services';

@Component({
  selector: 'app-marking-product-list',
  templateUrl: './marking-product-list.component.html',
  styleUrls: ['./marking-product-list.component.css']
})
export class MarkingProductListComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  listData: MarkingProductData[] = [];
  paginationInput: any;
  paginationOutput: PaginationPageEvent;
  listParams: any;
  multiple: boolean = true;
  selectedItem: any;
  actionsList = ACTIONS_LIST;

  constructor(
    public ngProgress: NgProgress,
    private languageService: LanguageService,
    private notification: NotificationService,
    private apiMarkingProductService: ApiMarkingProductListService,
    private dialogModal: DialogModalService,
    public permissionAccess: PermissionService,
    private router: Router,
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.getList();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   * @param id 
   * @param action 
   */
  getAction(id: string, action: string) {

    let ids = [...new Set(this.listData.filter(val => val.checked).map(({ id }) => id))];

    if (this.checkState(action)) {

      switch (id) {

        case 'trade':

          this.sendProductData(ids);
          break;

        case 'moderation':

          this.sendToModeration(ids);
          break;

        case 'file':
          this.sendImportProductsPhotos(ids);
          break;

        case 'registration':
          this.sendToRegistration(ids);
          break;

        case 'get_xml':
          this.getProductsXmls(ids);
          break;

        case 'delete':
          this.deleteSelected(ids);
          break;

        default:
        this.notification.show('success', 'Запрашиваемое действие неопределено!');
        break;
      }
    }
  }

  /**
   * 
   * @param ids 
   */
  sendToRegistration(ids) {

    this.progressRef.start();

    this.subscriptions.add(
      this.apiMarkingProductService.sendTo('registerProducts', { id: ids }).subscribe(response => {
        console.log('[RESPONSE] registerProduct: ', response);

        if (response != null) {

          this.getList();

          this.notification.show('success', 'Данные успешно отправлены!');
        }

        this.progressRef.complete();
      })
    );
  }

  /**
   * 
   * @param ids 
   */
  sendProductData(ids) {

    this.progressRef.start();

    this.subscriptions.add(
      this.apiMarkingProductService.sendTo('sendProducts', { id: ids }).subscribe(response => {
        console.log('[RESPONSE] sendToModeration: ', response);

        if (response != null) {

          this.getList();

          this.notification.show('success', 'Данные успешно отправлены!');
        }

        this.progressRef.complete();
      })
    );

  }

  /**
   * 
   * @param ids 
   */
  sendToModeration(ids) {

    this.progressRef.start();

    this.subscriptions.add(
      this.apiMarkingProductService.sendTo('sendToModeration', { id: ids }).subscribe(response => {
        console.log('[RESPONSE] sendToModeration: ', response);

        if (response != null) {

          this.getList();

          this.notification.show('success', 'Данные успешно отправлены!');
        }

        this.progressRef.complete();
      })
    );

  }

  /**
   * 
   * @param ids 
   */
  sendImportProductsPhotos(ids) {

    this.progressRef.start();

    this.subscriptions.add(
      this.apiMarkingProductService.sendTo('sendImportProductsPhotos', { id: ids }).subscribe(response => {
        console.log('[RESPONSE] sendImportProductsPhotos: ', response);

        if (response != null) {

          this.getList();

          this.notification.show('success', 'Данные успешно отправлены!');
        }

        this.progressRef.complete();
      })
    );

  }


  /**
   * 
   */
   getProductsXmls(ids:string[] = null){

    this.progressRef.start();

    ids != null ? ids : ids = [...new Set(this.listData.filter(val => val.checked).map(({ id }) => id))];

    this.subscriptions.add(
      this.apiMarkingProductService.getProductsXmls('getProductsXmls', { id: ids , publicationAgreement: true }).subscribe(response => {
        console.log('[RESPONSE] getProductsXmls: ', response);

        if (response != null) {

          this.openModalEDS(response.result.xmls);

          // this.notification.show('success', 'Данные успешно отправлены!');
        }

        this.progressRef.complete();
      }, error=> {console.log("ERROR");
      })
    );

  }

  
  /**
   * 
   * @param xml 
   */
  openModalEDS(signData: any[]): void {

    let signedData:any[] = [];

    let xml = signData.map(val => val.xml);

    this.dialogModal.open(xml, EdsComponent).then(
      (result) => {

        if (result) {

          console.log("RESULT EDS: ", result);

          for(let s of signData){

            for(let r of result){

              signedData.push({goodId: s.goodId, xml: r})
            }

           
          }
          console.log(signedData);
          
          
          this.sendSignedXmls(signedData);
        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
   * 
   */
  sendSignedXmls(data:any[]){

    this.subscriptions.add(
      this.apiMarkingProductService.getProductsXmls('sendSignedXmls', {data}).subscribe(response => {
        console.log('[RESPONSE] getProductsXmls: ', response);

        if (response != null) {

          this.notification.show('success', 'Данные успешно отправлены!');
        }

        this.progressRef.complete();
      })
    );
  }


  /**
   * 
   */
  getList(): void {

    this.progressRef.start();
    this.loading = true;
    this.listData = [];

    this.setListParams();

    this.apiMarkingProductService.getList(this.listParams).subscribe((response: Res) => {
      console.log('[RESPONSE] getPrices: ', response);

      if (response) {

        if (response.result != null) {

          this.listData = response.result.list;

          this.paginationInput = {
            count: response.result.count,
            numberOfPages: response.result.numberOfPages,
            currentPage: this.listParams.pageNumber,
            size: this.listParams.countOnPage
          }
        }
      }

      this.progressRef.complete();
      this.loading = false;
    },
      error => {
        this.progressRef.complete();
        this.loading = false;
      });
  }

  /**
   * 
   */
  setListParams(): void {

    this.listParams = {
      filter: {
        org_id: null
      },
      pageNumber: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 1 : this.paginationOutput.pageNumber,
      countOnPage: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 10 : this.paginationOutput.pageSize
    }
  }


  /**
   * 
   * @param event PaginationPageEvent
   */
  pageEvent(event: PaginationPageEvent): void {

    this.paginationOutput = event;
    this.getList();
  }


  /**
   * 
   */
  getProfile(id: string) {

    let data = {
      id: id
    }

    this.dialogModal.open(data, MarkingProductProfileComponent).then(
      (result) => {

        if (result) {

        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
   * 
   */
  onCreate() {

    let data = {

    }

    this.dialogModal.open(data, MarkingProductCreateComponent).then(
      (result) => {

        if (result) {

          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
   * 
   * @param product_id 
   */
  onEdit(product_id) {

    this.router.navigate(['products', 'edit', product_id]);
  }


  /**
   * 
   * @param ids 
   */
  onDelete(ids: string[]): void {

    this.progressRef.start();

    this.subscriptions.add(
      this.apiMarkingProductService.delete({ id: ids }).subscribe(response => {
        console.log('[RESPONSE] deletePrice: ', response);

        if (response != null) {

          this.getList();

          this.notification.show('success', 'Данные успешно удалены!');
        }

        this.progressRef.complete();
      })
    );
  }


  /**
   * 
   */
  deleteSelected(ids): void {

    this.onDelete(ids);
  }


  /** CHECKBOX */

  /**
   * 
   * @param index number
   * @param event 
   */
  selectedCheckBox(index: number, event: any): void {

    this.listData[index].checked = event.target.checked;
  }


  /**
   * 
   * @param event 
   */
  checkAllCheckBox(event: any): void {

    this.listData.forEach(x => x.checked = event.target.checked)
  }


  /**
   * 
   * @returns boolean
   */
  isAllCheckBoxChecked(): boolean {

    if (this.listData.length == 0) return false;

    return this.listData.every(p => p.checked);
  }


  /**
   * 
   * @returns boolean
   */
  checkedButNotAllCheckBox(): boolean {

    let pl = this.listData.length;
    let pc = this.listData.filter(val => val.checked).length;

    return (pc > 0 && pc < pl) ? true : false;
  }


  /**
   * 
   * @returns boolean
   */
  checkedCheckBox(): boolean {

    let pc = this.listData.filter(val => val.checked).length;

    return (pc > 0) ? true : false;
  }

  /**
    * 
    * @returns boolean
    */
  checkState(action: string): boolean {

    if (this.checkedCheckBox()) {

      let pc = this.listData.find(val => val.checked && !this.permissionAccess.check(action, val.state.id));
    
      return pc ? false : true;

    }

    return false;

  }

}
